import axios from 'axios';

const fetchMaler = async (API_BASE_URL, userId) => {
  try {
    const res = await axios.get(`${API_BASE_URL}/templates`, {
      headers: {
        'X-User-Id': userId,
        'Content-Type': 'application/json'
      }
    });
    return res.data;
  } catch (error) {
    console.error("Error fetching templates:", error);
    throw error;
  }
};

const updateMal = async (API_BASE_URL, userId, title, content, oldTitle = null) => {
  try {
    // Hent eksisterende maler først
    const maler = await fetchMaler(API_BASE_URL, userId);
    
    // Oppdater malene
    let updatedTemplates = { ...maler };
    if (oldTitle && oldTitle !== title) {
      delete updatedTemplates[oldTitle];
    }
    updatedTemplates[title] = content;
    
    // Lagre oppdaterte maler
    await axios.post(`${API_BASE_URL}/templates`, updatedTemplates, {
      headers: {
        'X-User-Id': userId,
        'Content-Type': 'application/json'
      }
    });
    
    return updatedTemplates;
  } catch (error) {
    console.error("Error updating template:", error);
    throw error;
  }
};

const deleteMal = async (API_BASE_URL, userId, title) => {
  try {
    // Hent eksisterende maler først
    const maler = await fetchMaler(API_BASE_URL, userId);
    
    // Fjern malen
    let updatedTemplates = { ...maler };
    delete updatedTemplates[title];
    
    // Lagre oppdaterte maler
    await axios.post(`${API_BASE_URL}/templates`, updatedTemplates, {
      headers: {
        'X-User-Id': userId,
        'Content-Type': 'application/json'
      }
    });
    
    return updatedTemplates;
  } catch (error) {
    console.error("Error deleting template:", error);
    throw error;
  }
};

export {
  fetchMaler,
  updateMal,
  deleteMal
};